import React from 'react';

const languages = [
  'Access to Finance', 'Regulatory and Compliance Burdens', 'Market Access and Competition', 
  'Skills Gaps', 'Infrastructure and Technology Access', 'Cash Flow and Late Payments', 'Limited Mentorship and Support Networks', 'Economic and Political Instability',
  'Lack of Innovation and Differentiation', 'Access to Information and Opportunities','Crime & Insecurity', 'Others',
];

const IndustrySection = ({
  selected = [],
  setSelected,
  vision = "",
  setVision,
  onSave
}) => {
  const handleSelect = (lang) => {
    if (selected.includes(lang)) {
      setSelected(selected.filter(item => item !== lang));
    } else {
      setSelected([...selected, lang]);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        SECTIONF: "INDUSTRY ACTIVITY SURVEY", // Replace or populate as needed
        section: "Industry Activity Survey",
        vision,
        selectedChallenges: selected,
      });
    }
  };

  return (
    <div className='md:mt-20 mt-12'>
      <div className="flex items-center justify-between">
        <h1 className='md:text-[36px] text-[10px] font-bold text-center mx-auto w-full'>
          SECTION F: INDUSTRY ACTIVITY SURVEY
        </h1>
        <img 
          src='https://res.cloudinary.com/dzngpgki4/image/upload/v1746297211/Expand_down_18_nrspje.png' 
          alt='icon' 
          className='md:w-[38px] md:h-[38px] w-[14px] h-[14px]'
        />
      </div>
      {/* Vision input */}
      <div className='md:mt-6'>
        <h1 className='md:text-[32px] font-bold text-[6px]'>
          What would you like to achieve (your vision and goals) in your Enterprise pursuits and activities?
        </h1>
      </div>
      <div className='md:mt-6 mt-1'>
        <input
          type='input'
          value={vision}
          onChange={e => setVision(e.target.value)}
          className='bg-[#E7EBEB] rounded-[5px] w-full md:h-[171px] pl-2 h-[20px] md:pb-20 placeholder:text-black text-black md:pl-6 text-[6px] md:text-[24px] font-normal'
          placeholder='I would like to...'
        />
      </div>
      {/* Challenges multiple select */}
      <div className='md:mt-6 mt-3'>
        <h1 className='md:text-[32px] text-[8px] font-bold'>
          What are your biggest challenges and hurdles in achieving your vision and goals?
        </h1>
        <p className='md:text-[24px] text-[6px] italic font-light'>Select all that apply to you.</p>
      </div>
      {/* Buttons grid */}
      <div className="grid grid-cols-3 md:gap-2 gap-1 md:mt-5 mt-2">
        {languages.map((lang, i) => {
          const isActive = selected.includes(lang);
          return (
            <button
              key={i}
              onClick={() => handleSelect(lang)}
              className={`
                flex items-center justify-between
                w-full md:h-[80px] h-[20px] text-left
                bg-[#E7EBEB]
                border border-[#E7EBEB] rounded-[5px]
                md:px-4 px-2
              `}
            >
              <span className="font-medium text-[4px] md:text-[24px] md:w-[305px] leading-[1.10]">{lang}</span>
              <span
                className={`
                  md:w-14 md:h-14 w-3 h-3 rounded-full
                  ${isActive 
                    ? 'bg-[#03897B] md:border-[8px] border-[3px] border-white'
                    : 'md:border-[8px] border-[3px] border-white bg-transparent'}
                `}
              />
            </button>
          );
        })}
      </div>

      <div className="md:h-20 h-4"></div>
    </div>
  );
}

export default IndustrySection;